import { useQuery } from '@tanstack/react-query';
import type { VirtualNode } from '@components/VirtualRenderer/types';
import fetchMarketFeed, {
  getMarketFeedQueryKey,
} from '../query/fetchMarketFeed';
import type { PrimaryCountryISO } from '@/constants/countries';

interface FeedItem {
  id: string;
  date: number | null;
  dateFormatted: string;
  title?: string;
  text: string;
  thumbnail?: string;
  outcome?: number | null;
  type:
    | 'multi-event'
    | 'event'
    | 'article'
    | 'external-article'
    | 'brief'
    | 'narrative';
  subType: string;
  url: string;
  virtual?: VirtualNode[];
  provider?: string;
  activityId: string;
  authorImageUrl?: string;
}

export interface MarketFeedCompanyEvents {
  companyId: string;
  name: string;
  canonicalUrl: string;
  tickerSymbol: string;
  sharePriceFormatted: string;
  return7D: number | null;
  return1YrAbs: number | null;
  feedItems: FeedItem[];
  scores: [number, number, number, number, number];
}

interface HookResponse {
  isFetching: boolean;
  isLoading: boolean;
  data: MarketFeedCompanyEvents[];
}

export default function useMarketFeed(
  market: PrimaryCountryISO,
  industryId: number,
  enabled?: boolean
): HookResponse {
  const {
    isLoading,
    isFetching,
    data = [],
  } = useQuery({
    queryKey: getMarketFeedQueryKey(market, industryId),
    queryFn: fetchMarketFeed,
    staleTime: Infinity,
    retry: 1,
    enabled,
    refetchOnMount: false,
  });

  return {
    isLoading,
    isFetching,
    data,
  };
}
